import * as Yup from "yup";
import { SocietyParamsSchema } from "shared/yup-validators/schemas/society/[societyId]/societySchema";

export const SocietyProfileParamsSchema = SocietyParamsSchema.concat(
  Yup.object().shape({
    profileId: Yup.number().required(),
  }),
);

export const SocietyProfileStatusParamsSchema =
  SocietyProfileParamsSchema.concat(
    Yup.object().shape({
      refProfileStatusId: Yup.number().required(),
    }),
  );
